/* eslint-disable no-underscore-dangle */
import React, { useState, useEffect } from 'react';
import {
  Table, Tag, Icon, Button, message, Select, Modal, Input,
} from 'antd';
import { Link } from 'react-router-dom';
import postApi from 'utils/api/posts/PostApi';
import HandleProviders from 'utils/table/HandleProviders';
import HandlePostIdUrl from 'utils/table/HandlePostIdUrl';
import PostTypeParser from 'utils/table/PostTypeParser';
import PostCreateDateParser from 'utils/table/PostCreateDateParser';
import moment from 'moment';
import ActionsMenu from './PostsTable/ActionsMenu';
import './PostsTable.less';

const { Option } = Select;
const { confirm } = Modal;
const { Search } = Input;

const { localStorage } = window;

const PostsTable = () => {
  const [userRequest, setUserRequest] = useState({
    currentPage: 1,
    flightData: [],
    authors: [],
    limit: 10,
    loading: true,
    total: 0,
    sortBy: '',
    order: '',
  });

  const [searchValue, setSearchValue] = useState('');

  const {
    loading, flightData, authors, limit, currentPage, total, sortBy, order,
  } = userRequest;

  const token = localStorage.getItem('token');

  /**
   * success callback
   * @param {object} flights
   * @param {number} limitNumber
   */
  const getPostSuccess = (flights, limitNumber) => {
    if (Object.keys(flights.data).length > 0) {
      const authorSet = new Set();
      flights.data.map((e) => authorSet.add(e.author.name));
      const authorsFilters = Array.from(authorSet).map((e) => Object({ value: e, text: e }));
      setUserRequest({
        currentPage: flights.current_page,
        flightData: flights.data,
        authors: authorsFilters,
        limit: limitNumber,
        loading: false,
        order: flights.order,
        sortBy: flights.sort_by,
        total: flights.results,
      });
    } else {
      setUserRequest({
        flightData: [],
        loading: false,
      });
    }
  };

  /**
   * fail
   * @param {error} error
   * @returns {MessageType}
   */
  const getPostFail = (error) => message.error(error.toString(), 5);

  /**
   * copy success
   * @return {MessageType}
   */
  const copySuccess = () => {
    message.success('Está en tu clipboard', 3);
  };

  /**
   * calling the getPosts
   * @param {object} params
   */
  const getPosts = (params = {}) => {
    postApi
      .getPost(params, token)
      .then((response) => getPostSuccess(response.data, params.limit))
      .catch((err) => getPostFail(err));
  };

  /**
   * handle tab method, (pagination, filters and sorts)
   * @param _ , ignored function param
   * @param {object} pagination
   * @param {object} sorts
   */
  const handleTabChange = (pagination, _, sorts) => {
    setUserRequest({
      currentPage: pagination.current,
      flightData: [],
      limit,
      loading: true,
      order: sorts.order,
      sortBy: sorts.field,
      total: 0,
    });
    getPosts({
      page: pagination.current,
      limit,
      sort_by: sorts.field,
      order: sorts.order,
    });
  };

  /**
   * method to handle the title click to open the Post
   * @param {object} row, row clicked
   */
  const handleTitleClick = (row) => {
    // TODO: Enviar a la vista del tipo de post o traerlo para redireccionar
    const postType = {
      1: '/oferta-general/',
      2: '/vuelo-sencillo/',
      3: '/vuelo-redondo/',
      4: '/vuelo-mas-hotel/',
      5: '/oferta-hotel/',
    };
    const resp = `${postType[row.type].replace(/ /g, '-').toLowerCase()}${row._id}`;
    return resp;
  };

  /**
   * @param {string} text The row value.
   * @param {string} status The offer status to expired.
   * @param {string} className The container name
   * @returns {*}, the row span.
   */
  const renderTextRow = (text = '', status, className) => {
    const classSpanText = status ? 'posts-expired-offer' : `${className}-span-text`;
    return (
      <span className={className}>
        <span className={text ? classSpanText : 'text-undefined'}>{text}</span>
      </span>
    );
  };

  /**
   *  method to render the title span
   * @param {string} text, the text to render
   * @param {boolean} expired, expired boolean
   * @param {object} record
   * @param {string} className
   * @returns {*}
   */
  const renderTitleRow = (text = '', expired, record, className) => {
    const classSpanText = expired ? 'posts-button-expired-offer' : `${className}-span-button`;
    return (
      <span className={className}>
        <Link to={handleTitleClick(record)} className={`${classSpanText} wrap-posts-title-text`}>
          {text}
        </Link>
      </span>
    );
  };

  /**
   * method to show action confirm modal
   * @param {object} actionMessage
   * @param {string} okType
   * @param {string} okText
   * @param {string} cancelText
   * @param {function} onOkHandler
   */
  const showActionConfirm = (actionMessage, okType, okText, cancelText, onOkHandler) => {
    const { title, content } = actionMessage;
    confirm({
      title,
      content,
      onOk() {
        onOkHandler();
      },
      okType,
      okText,
      cancelText,
    });
  };

  /**
   * Refresh table according to post update and preview logic
   * @param {object} id, postId to be updated
   * @param {number} postId, use for preview
   * @param {string} action, Action to be executed in selected postId
   * @param {string} successMessage, Message that will be displayed on success
   */
  const updateTable = (id, action, successMessage, postId) => {
    if (action === 'preview') {
      const url = `${process.env.REACT_APP_EIFFEL}/?p=${postId || 1}&token=${token}`;
      window.open(url, '_blank');
    } else {
      postApi
        .actionPost(id, { action }, token)
        .then(() => {
          message.success(successMessage);
          getPosts({
            page: currentPage,
            limit,
            sort_by: sortBy,
            order,
          });
        })
        .catch((err) => message.error(err));
    }
  };

  /**
   * method to get the postId of the post to *ACTION* (EXPIRE, TRASH, PREVIEW)
   * @param {object} action, the action called
   */
  const handleActionMenuClick = (action) => {
    const actionTitle = {
      delete: 'Eliminar Oferta',
      expire: 'Expirar Oferta',
      preview: 'Visualizar Oferta',
      recover: 'Recuperar Oferta',
      restore: 'Restaurar Oferta',
    };
    const confirmType = {
      expire: 'danger',
      delete: 'danger',
      preview: 'confirm',
    };
    const confirmButton = 'Si, continuar';
    const cancelButton = 'Cancelar';
    const successMessage = {
      expire: 'Post Expirado',
      recover: 'Post Recuperado',
      delete: 'Post Eliminado',
      restore: 'Post Restaurado',
    };
    const actionMessages = {
      delete: 'Estás a punto de borrar una oferta.',
      expire: 'Estás a punto de expirar una oferta.',
      recover: 'Estás a punto de volver a publicar.',
      restore: 'Estás a punto de restaurar una oferta.',
    };
    const contentMessage = (
      <div className="confirm-action-container">
        <div className="confirm-action-body-title">{actionMessages[action.current]}</div>
        <div>¿Deseas continuar?</div>
      </div>
    );

    showActionConfirm(
      {
        title: actionTitle[action.current],
        content: contentMessage,
      },
      confirmType[action.current],
      confirmButton[action.current],
      cancelButton,
      () => updateTable(action.id, action.current, successMessage[action.current], action.postId),
    );
  };

  /**
   * method to use the execCommand HTML API
   * https://developer.mozilla.org/en-US/docs/Web/API/Document/execCommand
   * @param id
   */
  const handleOnCopy = (id) => {
    const input = document.createElement('input');
    input.value = document.getElementById(`copy-to-clipboard-button-${id}`).value;
    input.id = 'copy-input-id';
    document.body.appendChild(input);
    input.select();
    document.execCommand('copy');
    document.body.removeChild(input);
    copySuccess();
  };

  /**
   * method to handle the posts limit
   * @param limitSelected
   */
  const handleLimitChange = (limitSelected) => {
    getPosts({
      order,
      sortBy,
      limit: limitSelected,
      page: 1,
    });
  };

  // To ignore the sorter and filters on table coverage
  /* istanbul ignore next */
  const columns = [
    {
      title: 'Título de Post',
      dataIndex: 'title',
      key: 'title',
      render: (text, record) => renderTitleRow(text, record.expired, record, 'table-row-post-title'),
      sorter: () => 0,
    },
    {
      title: 'Autor',
      dataIndex: 'author',
      key: 'author',
      render: (text, record) => renderTextRow(text.name, record.expired, 'table-row-post-author'),
      filters: authors,
      onFilter: (value, record) => record.author.name === value,
    },
    {
      title: 'Proveedor',
      dataIndex: 'providers',
      key: 'providers',
      render: (text, record) => renderTextRow(HandleProviders(text), record.expired, 'table-row-post-provider'),
    },
    {
      title: 'Tipo de Oferta',
      dataIndex: 'type',
      key: 'type',
      render: (text, record) => renderTextRow(PostTypeParser(text), record.expired, 'table-row-post-type'),
      sorter: () => 0,
    },
    {
      title: 'Estado',
      dataIndex: 'status',
      key: 'status',
      render: (status, record) => {
        const colors = { publish: 'green', draft: 'blue', trash: '#455a64' };
        let color = colors[status];
        let label = status;
        if (record.expired) {
          label = 'expired';
          color = 'red';
        }
        if (moment(record.publish_date).isAfter(moment())) {
          label = `${status} ⏰`;
        }
        return (
          <span className="posts-table-content-element">
            <Tag color={color} key={label}>
              {label}
            </Tag>
          </span>
        );
      },
    },
    {
      title: 'Fecha/Hora de Creación',
      dataIndex: 'created_at',
      key: 'created_at',
      render: (text, record) => renderTextRow(PostCreateDateParser(text), record.expired, 'table-row-post-date'),
      sorter: () => 0,
    },
    {
      title: 'Acciones',
      dataIndex: 'actions',
      key: 'actions',
      render: (_, record) => (
        <span className="posts-table-content-element">
          <ActionsMenu status={record.status} expired={record.expired} onClick={handleActionMenuClick} id={record._id} postId={record.id} />
        </span>
      ),
    },
    {
      title: 'Facebook URL',
      dataIndex: 'facebookURL',
      key: 'facebookURL',
      render: (_, record) => (
        <span>
          <Button
            id={`copy-to-clipboard-button-${record.id}`}
            onClick={() => handleOnCopy(record.id)}
            type="default"
            value={HandlePostIdUrl(record.id)}
          >
            <Icon type="link" />
          </Button>
        </span>
      ),
    },
  ];

  /**
   * use effect (HOOK)
   */
  useEffect(() => {
    getPosts();
  }, []);

  const getFligthData = () => {
    let data = flightData;
    if (searchValue.length > 0) {
      data = flightData.filter((e) => e.title.toLowerCase().includes(searchValue));
    }
    return data;
  };

  // Columns: the table columns.
  // dataSource: the data from server (STORE).
  // loading: to show the loading spinner.
  return (
    <div className="posts-table-container">
      <div className="posts-table-limit-container">
        <div className="post-table-search-row">
          <Search
            placeholder="Buscar por Titulo"
            onSearch={(value) => {
              setSearchValue(value);
            }}
            enterButton
            allowClear
          />
        </div>
        <div className="posts-table-limit-row">
          <p className="posts-table-limit-text">Mostrar</p>
          <Select className="posts-table-limit" defaultValue={limit} onChange={handleLimitChange}>
            <Option value={10}>10</Option>
            <Option value={20}>20</Option>
            <Option value={50}>50</Option>
            <Option value={100}>100</Option>
          </Select>
          <p className="posts-table-limit-text">entradas</p>
        </div>
      </div>
      <div className="posts-table-content">
        <Table
          rowKey={(record) => record.id}
          locale={{
            emptyText: 'Ups, no hay datos :(',
          }}
          pagination={{
            showQuickJumper: true,
            current: currentPage,
            total,
            pageSize: limit,
          }}
          columns={columns}
          dataSource={getFligthData()}
          onChange={handleTabChange}
          rowClassName={(record, index) => {
            if (index % 2) {
              return 'background-gray';
            }
            return 'background-white';
          }}
          loading={loading}
        />
      </div>
    </div>
  );
};

export default PostsTable;
